import { HttpClient } from '@angular/common/http';
import { Postcode, PostcodeSearchRequest } from '@jms/model';
import { Subject, BehaviorSubject } from 'rxjs';
import { debounceTime, filter, map, catchError } from 'rxjs/operators';
import * as Enumerable from 'linq';

export class PostcodeSearcher {
  protected _searchSubject = new Subject<PostcodeSearchRequest>();
  public data$ = new BehaviorSubject<Postcode[]>([]);

  constructor(
    private http: HttpClient,
    private endPoint: string,
    private allowReturnAll,
    private existing: any) {

    this._searchSubject
      .pipe(
        debounceTime(300),
        filter(query => {
          if (this.allowReturnAll) return true;
          return query ? true : false;
        })
      )
      .subscribe(query => {
        this.getData(query);
      });
  }

  public search(search?: PostcodeSearchRequest) {
    this._searchSubject.next(search);
  }

  public getData(search?: PostcodeSearchRequest, existing: () => Postcode[] = () => []) {
    const url = search ? `${this.endPoint}?${this.toQueryString(search)}` : this.endPoint;

    this.http
      .get<Postcode[]>(url)
      .pipe(
        map(categories => {
          const data = Enumerable.from(categories)
            .except(existing(), c => (<any>c).name)
            .toArray() as Postcode[];

          this.data$.next(data);
        }),
        catchError(x => {
          return null;
        })
      )
      .subscribe();
  }

  private toQueryString(paramsObject) {
    return Object.keys(paramsObject)
      .filter(key => paramsObject[key])
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`)
      .join('&');
  }
}
